module.exports = __webpack_public_path__ + "img/OCT-French-Lace-Hair-System-with-NPU-Back-Sides-and-Double-Layered-Lace-Front-3-300x300.e94c4af5.jpg";